<div class="ap-impact">
    <p class="ap-section-label">{{ section.label }}</p>
    <div class="ap-impact-panel"
         [class.tone-info]="(section.tone || 'info') === 'info'"
         [class.tone-success]="section.tone === 'success'"
         [class.tone-warning]="section.tone === 'warning'">
        <p class="ap-impact-primary">{{ displayPrimary }}</p>
        <p class="ap-impact-secondary" *ngIf="displaySecondary">{{ displaySecondary }}</p>
    </div>
</div>
